module.exports = __webpack_public_path__ + "img/Watermark_Lock@2x.00186161.png";